import { createMessageForExistingConversation,createMessageForNewConversation, createSignedPrerenderedConversation } from 'api/messages'
import { AxiosResponse } from 'axios'
import store from 'config/store'
import { NEW_CONVERSATION_ID,PRERENDERED_CONVO_ID } from 'constants/conversations'
import {
  triggerConversationStartedAPIEvent,
  triggerMessageSentAPIEvent
} from 'modules/api/events'
import { isNewConversation,isPrerenderedConversation } from 'modules/conversations/utils'
import { sendMessageRoundTripMetric } from 'modules/message/metrics/roundTrip'
import { pathOr, values } from 'ramda'
import { ConversationId } from 'types/conversation'
import { Message } from 'types/message'
import { error } from 'utils'

export const sendMessage = (endUserMessage: Message): Promise<void | AxiosResponse<Message>> => {
  const { conversations = {} } = store.getState()
  const activeConversationId: ConversationId = pathOr(NEW_CONVERSATION_ID, ['activeConversation'], conversations)
  const isFirstMessageInPrerenderedCampaign = isPrerenderedConversation(activeConversationId)

  if (isFirstMessageInPrerenderedCampaign) {
    return sendMessageForPreRenderedConversation(endUserMessage)
  }

  if (isNewConversation(endUserMessage.conversationId) || !endUserMessage.conversationId) {
    return sendMessageForNewConversation(endUserMessage)
  }

  return sendMessageForExistingConversation(endUserMessage)
}

const sendMessageForPreRenderedConversation = (endUserMessage: Message) => {
  const { conversations = {} } = store.getState()
  const prerenderedMessages = pathOr([], ['messages', PRERENDERED_CONVO_ID], conversations)

  const signedMessages = values(prerenderedMessages).slice(0, -1)

  return createSignedPrerenderedConversation(signedMessages, endUserMessage)
    .then((response) => {
      onMessageSent(response.data, false)
      return response
    })
    .catch((err) => {
      onMessageFailed(endUserMessage, err)
    })
}

const sendMessageForExistingConversation = (endUserMessage: Message) => {
  return createMessageForExistingConversation(endUserMessage)
    .then((response) => {
      onMessageSent(response.data, false)
      return response
    })
    .catch((err) => {
      onMessageFailed(endUserMessage, err)
    })
}

const sendMessageForNewConversation = (endUserMessage: Message) => {
  return createMessageForNewConversation(endUserMessage)
    .then((response) => {
      onMessageSent(response.data, true)
      return response
    })
    .catch((err) => {
      onMessageFailed(endUserMessage, err)
    })
}

const onMessageFailed = (message: Message, err) => {
  const responseStatus = pathOr(null, ['response', 'status'], err)
  const errorCode = pathOr(null, ['code'], err)
  const requestTimedOut = errorCode && errorCode === 'ECONNABORTED'

  if (requestTimedOut) {
    sendMessageRoundTripMetric({ message, timedOut: true })
    return error(new Error('Sending message timed out'), err)
  }

  if (!responseStatus || responseStatus !== 403) {
    return error(new Error('Failed To send message'), err)
  }
}

const onMessageSent = (message: Message, isExistingConversation: boolean) => {
  if (!isExistingConversation) {
    triggerConversationStartedAPIEvent(message)
  }

  triggerMessageSentAPIEvent(message)
}
